// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-44587dee]{display:none}[data-v-44587dee] .base-loader__overlay{top:350px}.survey[data-v-44587dee]{align-items:center;display:flex;height:700px;justify-content:center;margin:auto;max-width:none}.survey__tripetto[data-v-44587dee]{max-width:1240px;width:100%}.survey[data-v-44587dee] #tripetto-runner{align-items:center;display:flex;justify-content:center}.survey[data-v-44587dee] iframe{height:700px;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
